import type { RefObject } from 'react'
import { useEffect, useMemo, useState } from 'react'

import { getOptimizedUrl } from '@disco/api/imgixClient'

type UseOptimizedImageParams = {
  image: string | null | undefined
  containerRef: RefObject<HTMLElement | null>
  params?: Record<string, any>
}

export const useOptimizedImage = ({
  image,
  containerRef,
  params,
}: UseOptimizedImageParams): string | null | undefined => {
  const [optimizedUrl, setOptimizedUrl] = useState<string | null | undefined>(
    image,
  )

  // Create a stable key from params to avoid re-running the effect
  // when params object reference changes but content is the same
  const paramsKey = useMemo(
    () => (params ? JSON.stringify(params) : undefined),
    [params],
  )

  useEffect(() => {
    if (!image) {
      setOptimizedUrl(null)
      return
    }

    const result = getOptimizedUrl({
      imageContainer: containerRef.current,
      image,
      params,
    })
    setOptimizedUrl(result || image)
    // paramsKey is used instead of params to avoid re-running when object reference changes but content is the same
  }, [image, containerRef, paramsKey])

  return optimizedUrl
}
